import { useUser } from "~/modules/user/hooks/useUser";
import { AccessSegment } from "./types";

// // // //

/**
 * useAccessSegment
 * Returns the current viewer's AccessSegment
 * ENHANCEMENT - map enterprise plans to AccessSegment.Enterprise once they exist
 */
export function useAccessSegment(): AccessSegment {
    const { isLoggedIn, isPaidPlan } = useUser();

    if (!isLoggedIn) {
        return AccessSegment.Free;
    }

    if (isPaidPlan) {
        return AccessSegment.Pro;
    }

    return AccessSegment.Preview;
}
